'use strict';

export class PopoverSelectTemplateService {
  generatePopoverTemplate(options, nullLabel) {
    const html = ['<ion-popover-view class="small-radius"><ion-content><div class="list">'];
    const groupMap = {};

    if (options.nullable)
      html.push(PopoverSelectTemplateService.generateOption(options.getNullOption(nullLabel), false));

    options.items.forEach(option => {
      if (option.group) {

        // This option is to live in a group
        // See if we have already created this group
        let group = groupMap[option.group];

        if (!group) {

         // Store it for use later
          group = groupMap[option.group] = {
            label: option.group,
            html: [],
          };

        }

        group.html.push(PopoverSelectTemplateService.generateOption(options.getNullOption(), options.multiple));

      } else {
        html.push(PopoverSelectTemplateService.generateOption(option, options.multiple));
      }
    });

    const groups = Object.keys(groupMap);
    if (groups.length > 0) {
      groups.forEach(key => {
        const group = groupMap[key];
        html.push(PopoverSelectTemplateService.generateGroupTemplate({label: group.label, html: group.html.join('')}));
      });
    }

    html.push('</div></ion-content></ion-popover-view>');

    return html.join('');
  }

  // TODO: select-multiple support
  static generateOption(option, allowMultiple) {
    return `<div class="item item-icon-right${option.className ? ` ${option.className}` : ''}" ${option.disabled
      ? `disabled="'true'"`
      : `ng-click="select('${option.selectValue}')"`}><span>${option.label}</span>${!allowMultiple
      ? `<i class="options-check ion-android-arrow-dropleft" ng-show="'${option.viewValue}'=== selection"></i></div>`
      : /* select multiple goes here */''}`;
  }

  static generateGroupTemplate(group) {
    return `<div class="item item-divider">${group.label}</div>${group.html}`;
  }
}

PopoverSelectTemplateService.$inject = [];



// WEBPACK FOOTER //
// ./src/js/core-components/popover-select/PopoverSelectTemplateService.js